import {NgModule} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {ToastrModule} from 'ngx-toastr';
import {SweetAlert2Module} from '@sweetalert2/ngx-sweetalert2';
import { AlertModule } from 'ngx-bootstrap';
import { ConsultaEstadoComponent } from 'src/app/modules/consultaestado/view/consultaestado.component';
import { ConsultaGFComponent } from './view/grupo-familiar.component';
import { ConsultaNDComponent } from './view/no-dependientes.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { EnvService } from '../../../environments/env.service';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [
        ConsultaEstadoComponent,
        ConsultaGFComponent,
        ConsultaNDComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ToastrModule,
        SweetAlert2Module,
        AlertModule.forRoot(),
        RecaptchaModule.forRoot(),
        SharedModule
    ],
    exports: [

    ],
    providers: [ EnvService, DatePipe ]
})

export class ConsultaEstadoModule { }

